import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  searchInput: {
    padding: spacing(1)
  }
}))
